'use client';

import { FONT_TEXT } from '@/app/fonts';
import { ShareableChart } from '@/components/blog/ShareableChart';

export function PartnershipROI() {
  return (
    <ShareableChart title="Partnership ROI - Traditional vs Value-First">
      <h3 className="text-lg font-bold text-gray-900 mb-1" style={{ fontFamily: FONT_TEXT }}>
        Traditional Referrals vs. Value-First Alliance
      </h3>
      <p className="text-sm text-gray-500 mb-6" style={{ fontFamily: FONT_TEXT }}>
        Why leading with value changes the entire economics of agent partnerships
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Traditional */}
        <div className="rounded-lg border border-gray-200 p-5 bg-gray-50">
          <h4 className="font-bold text-gray-900 mb-4" style={{ fontFamily: FONT_TEXT }}>Traditional Approach</h4>
          <div className="space-y-3" style={{ fontFamily: FONT_TEXT }}>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Your investment</span>
              <span className="font-medium text-gray-900">Time + coffee ($50–$100/mo)</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Agent motivation</span>
              <span className="font-medium text-gray-900">Loyalty / obligation</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Referrals/month</span>
              <span className="font-medium text-gray-900">0–2 (inconsistent)</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Close rate</span>
              <span className="font-medium text-gray-900">30–40%</span>
            </div>
            <div className="flex justify-between text-sm border-t pt-2">
              <span className="text-gray-600 font-medium">Monthly revenue</span>
              <span className="font-bold text-gray-900">$0–$3,200</span>
            </div>
          </div>
        </div>

        {/* Value-First */}
        <div className="rounded-lg border-2 p-5" style={{ borderColor: '#ff34a7', backgroundColor: '#fff5fb' }}>
          <h4 className="font-bold mb-4" style={{ fontFamily: FONT_TEXT, color: '#ff34a7' }}>Value-First Alliance</h4>
          <div className="space-y-3" style={{ fontFamily: FONT_TEXT }}>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Your investment</span>
              <span className="font-medium text-gray-900">Leads + co-marketing ($200–$500/mo)</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Agent motivation</span>
              <span className="font-medium text-gray-900">Self-interest (you bring value)</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Referrals/month</span>
              <span className="font-medium" style={{ color: '#ff34a7' }}>3–8 (growing)</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Close rate</span>
              <span className="font-medium" style={{ color: '#ff34a7' }}>50–60%</span>
            </div>
            <div className="flex justify-between text-sm border-t pt-2">
              <span className="text-gray-600 font-medium">Monthly revenue</span>
              <span className="font-bold" style={{ color: '#ff34a7' }}>$6,000–$19,200</span>
            </div>
          </div>
        </div>
      </div>

      {/* Investment context */}
      <div className="mt-4 p-3 rounded-lg border-l-4" style={{ borderColor: '#ff34a7', backgroundColor: '#fff5fb' }}>
        <p className="text-sm font-semibold text-gray-900 mb-1" style={{ fontFamily: FONT_TEXT }}>
          What "Value-First" investment actually looks like:
        </p>
        <p className="text-xs text-gray-600" style={{ fontFamily: FONT_TEXT }}>
          Buyer lead introductions, co-sponsoring local events, shared marketing tools, and co-marketing resources — activities that deliver genuine value to agents and their clients. At $200–$500/month generating $6K–$19K in revenue, that's a 12–38× monthly return.
        </p>
      </div>

      <p className="text-xs text-gray-400 mt-3" style={{ fontFamily: FONT_TEXT }}>
        Source: leadpops.com · Based on ~$4K avg commission · Results vary by market, relationship quality, and consistency
      </p>
    </ShareableChart>
  );
}
